import { render } from "./UserId.vue?vue&type=template&id=2d1ad155"
import script from "./UserId.vue?vue&type=script&lang=js"
export * from "./UserId.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/dev_forward/data/www/dev.forward-ua.com/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__